import { makeStyles, tokens } from "@fluentui/react-components";

export const useErrorBoundaryStyles = makeStyles({
  container: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    textAlign: "center",
  },
  title: {
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground1,
  },
  message: {
    marginBottom: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground2,
  },
  errorMessage: {
    color: tokens.colorPaletteRedForeground1,
    fontFamily: "monospace",
    padding: tokens.spacingVerticalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: "4px",
    maxWidth: "100%",
    textWrap: "balance",
    overflow: "auto",
  },
});
